import React from 'react';
import { useTranslation } from '@/src/i18n';

const SearchCardAvailabilitiesErrorFallback = () => {
  const { t } = useTranslation();
  return (
    <div className=" no-availability">
      <span className="info-availability">
        {t('error-showing-availabilities')}
      </span>
    </div>
  );
};

export default SearchCardAvailabilitiesErrorFallback;
